<template>
    <div class="mx-auto w-full max-w-screen-2xl pt-0 pb-40 px-8">
        <div class="flex space-x-8" v-if="applicationForPayment" :key="applicationForPaymentKey">
            <div class="flex-1">
                <div class="sticky top-0 bg-white -mx-2 pt-4 px-2 mb-2 z-50">
                    <ui-header :title="'Application for Payment'" :subtitle="applicationForPayment.id">
                    </ui-header>
                    <div class="pt-3">
                        <div @click="mode='summary'"
                             class="inline-block m-1 border-0 shadow-none px-3 py-2 font-medium text-sm rounded-md focus:z-20 focus:outline-none "
                             style="min-width: 20px;cursor: pointer"
                             :class="mode==='summary'?'bg-blue-100 text-blue-700 focus:ring-2 focus:ring-blue-600':''"
                        >Summary
                        </div>
                        <div @click="mode='measure'"
                             class="inline-block m-1 border-0 shadow-none px-3 py-2 font-medium text-sm rounded-md focus:z-20 focus:outline-none "
                             style="min-width: 20px;cursor: pointer"
                             :class="mode==='measure'?'bg-blue-100 text-blue-700 focus:ring-2 focus:ring-blue-600':''"
                        >Measure of Works
                        </div>
                        <div @click="mode='preliminaries'"
                             class="inline-block m-1 border-0 shadow-none px-3 py-2 font-medium text-sm rounded-md focus:z-20 focus:outline-none "
                             style="min-width: 20px;cursor: pointer"
                             :class="mode==='preliminaries'?'bg-blue-100 text-blue-700 focus:ring-2 focus:ring-blue-600':''"
                        >Preliminaries
                        </div>
                        <div @click="mode='dayworks'"
                             class="inline-block m-1 border-0 shadow-none px-3 py-2 font-medium text-sm rounded-md focus:z-20 focus:outline-none "
                             style="min-width: 20px;cursor: pointer"
                             :class="mode==='dayworks'?'bg-blue-100 text-blue-700 focus:ring-2 focus:ring-blue-600':''"
                        >Dayworks
                        </div>
                        <div @click="mode='materials'"
                             class="inline-block m-1 border-0 shadow-none px-3 py-2 font-medium text-sm rounded-md focus:z-20 focus:outline-none "
                             style="min-width: 20px;cursor: pointer"
                             :class="mode==='materials'?'bg-blue-100 text-blue-700 focus:ring-2 focus:ring-blue-600':''"
                        >Unfixed Materials
                        </div>
                    </div>
                    <div>
                        <div v-if="mode==='measure'"
                             class="flex mt-1 flex-grow px-2 bg-gray-50 border-t border-b border-gray-200">
                            <div
                                class="flex flex-grow text-xs text-gray-500 font-semibold">
                                <div class="w-16 border-r border-gray-200 px-2 py-1">Ref</div>
                                <div class="flex-1 border-r border-gray-200 px-2 py-1">Description</div>
                                <div class="w-24 border-r border-gray-200 px-2 py-1">Quantity</div>
                                <div class="w-20 border-r border-gray-200 px-2 py-1">Item Value</div>
                                <div class="w-20 border-r border-gray-200 px-2 py-1">Complete</div>
                                <div class="w-24 border-r border-gray-200 px-2 py-1">% Apply for</div>
                                <div class="w-24 -ml-px border-gray-200 px-2 py-1">£ Apply for</div>
                            </div>
                        </div>
                        <div v-else-if="mode==='preliminaries'"
                             class="flex mt-1 flex-grow px-2 bg-gray-50 border-t border-b border-gray-200">
                            <div
                                class="flex flex-grow text-xs text-gray-500 font-semibold">
                                <div class="w-16 border-r border-gray-200 px-2 py-1">Ref</div>
                                <div class="flex-1 border-r border-gray-200 px-2 py-1">Description</div>
                                <div class="w-24 border-r border-gray-200 px-2 py-1">Quantity</div>
                                <div class="w-20 border-r border-gray-200 px-2 py-1">Item Value</div>
                                <div class="w-24 -ml-px border-gray-200 px-2 py-1">£ Apply for</div>
                            </div>
                        </div>
                        <div v-else-if="mode==='materials'"
                             class="flex mt-1 flex-grow px-2 bg-gray-50 border-t border-b border-gray-200">
                            <div
                                class="flex flex-grow text-xs text-gray-500 font-semibold">
                                <div class="w-6 border-gray-200 px-2 py-1"></div>
                                <div class="flex-1 border-r border-gray-200 px-2 py-1 -ml-px">Material</div>
                                <div class="w-24 border-r border-gray-200 px-2 py-1 -ml-px">UoM</div>
                                <div class="w-24 border-r border-gray-200 px-2 py-1 -ml-px">Unfixed Qty</div>
                                <div class="w-24 border-r border-gray-200 px-2 py-1 -ml-px text-right">£ Rate</div>
                                <div class="w-28 border-gray-200 px-2 py-1 -ml-px text-right">£ Total</div>
                                <div class="w-6 flex-shrink-0 ml-2"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <template v-if="mode==='summary'">
                    <div class="grid gap-6 grid-cols-12 pb-6 pt-2">
                        <div class="xl:col-span-6">
                            <div class="w-full mt-0 mb-1">Application Costings</div>
                            <div class="w-full border-gray-300 border rounded-lg p-0 m-0 mt-px">
                                <div
                                    class="flex mt-0 px-0 border-b rounded-t-lg border-gray-200 bg-gray-50 text-sm text-gray-500 font-semibold">
                                    <div class="flex-1 border-r border-gray-200 px-2 py-2 -ml-px">Cost Element</div>
                                    <div class="w-32 px-2 py-2 -ml-px text-right">Amount (£)</div>
                                </div>
                                <div
                                    class="flex mt-0 px-0 text-sm text-gray-500 border-gray-200 border-b font-semibold">
                                    <div class="flex-1 border-r border-gray-200 px-2 py-2 -ml-px">Original Contract
                                        Value
                                    </div>
                                    <div class="w-32 p-0 pt-2 pr-2 m-0 text-right"
                                         v-text="applicationForPayment.originalContractValue"></div>
                                </div>
                                <div
                                    class="flex mt-0 px-0 text-sm text-gray-500 border-gray-200 border-b font-semibold">
                                    <div class="flex-1 border-r border-gray-200 px-2 py-2 -ml-px">Agreed Variations
                                    </div>
                                    <div class="w-32 p-0 pt-2 pr-2 m-0 text-right"
                                         v-text="applicationForPayment.totalVariationsValue"></div>
                                </div>
                                <div
                                    class="flex mt-0 px-0 text-sm text-gray-700 border-gray-200 border-b font-semibold">
                                    <div class="flex-1 border-r border-gray-200 px-2 py-2 -ml-px">Contract Value to date
                                    </div>
                                    <div class="w-32 p-0 pt-2 pr-2 m-0 text-right"
                                         v-text="applicationForPayment.contractedWorksValue"></div>
                                </div>
                                <div
                                    class="flex mt-0 px-0 text-sm text-gray-500 border-gray-200 border-b">
                                    <div class="flex-1 border-l border-gray-200 px-2 py-2 -ml-px bg-gray-50"></div>
                                </div>
                                <div
                                    class="flex mt-0 px-0 text-sm text-gray-500 border-gray-200 border-b">
                                    <div class="flex-1 border-r border-gray-200 px-2 py-2 -ml-px">Measured Works</div>
                                    <div class="w-32 p-0 pt-2 pr-2 m-0 text-right" v-text="sumMeasuredWorks()"></div>
                                </div>
                                <div
                                    class="flex mt-0 px-0 text-sm text-gray-500 border-gray-200 border-b">
                                    <div class="flex-1 border-r border-gray-200 px-2 py-2 -ml-px">Anticipated
                                        Variations
                                    </div>
                                    <div class="w-32 px-0 m-0 border-r text-right">
                                        <page-cell
                                            class="text-right text-sm m-0 p-0 pt-2 pr-2 min-h-[38px]"
                                            :class="isReadOnly()?'border-transparent':'border-gray-400'"
                                            :placeholder="'£0.00'"
                                            :useTextareaReadonly="true"
                                            :disabled="isReadOnly()"
                                            :read-only="isReadOnly()"
                                            v-model="applicationForPayment.anticipatedVariations"
                                            @change="save"
                                        ></page-cell>
                                    </div>
                                </div>
                                <div
                                    class="flex mt-0 px-0 text-sm text-gray-500 border-gray-200 border-b">
                                    <div class="flex-1 border-r border-gray-200 px-2 py-2 -ml-px">Contra Charges</div>
                                    <div class="w-32 px-0 m-0 border-r text-right">
                                        <page-cell
                                            class="text-right text-sm m-0 p-0 pt-2 pr-2 min-h-[38px]"
                                            :class="isReadOnly()?'border-transparent':'border-gray-400'"
                                            :placeholder="'£0.00'"
                                            :useTextareaReadonly="true"
                                            :disabled="isReadOnly()"
                                            :read-only="isReadOnly()"
                                            v-model="applicationForPayment.contraCharges"
                                            @change="save"
                                        ></page-cell>
                                    </div>
                                </div>
                                <div
                                    class="flex mt-0 px-0 text-sm text-gray-500 border-gray-200 border-b">
                                    <div class="flex-1 border-r border-gray-200 px-2 py-2 -ml-px">Dayworks</div>
                                    <div class="w-32 px-0 m-0 border-r text-right">
                                        <page-cell
                                            class="text-right text-sm m-0 p-0 pt-2 pr-2 min-h-[38px]"
                                            :class="isReadOnly()?'border-transparent':'border-gray-400'"
                                            :placeholder="'£0.00'"
                                            :useTextareaReadonly="true"
                                            :disabled="isReadOnly()"
                                            :read-only="isReadOnly()"
                                            v-model="applicationForPayment.dayworks"
                                            @change="save"
                                        ></page-cell>
                                    </div>
                                </div>
                                <div
                                    class="flex mt-0 px-0 text-sm text-gray-500 border-gray-200 border-b">
                                    <div class="flex-1 border-r border-gray-200 px-2 py-2 -ml-px">Materials On-site
                                        (unfixed)
                                    </div>
                                    <div class="w-32 px-2 py-2 -ml-px text-right" v-text="totalOnSiteValue"></div>
                                </div>
                                <div
                                    class="flex mt-0 px-0 text-sm text-gray-500 border-gray-200 border-b">
                                    <div class="flex-1 border-r border-gray-200 px-2 py-2 -ml-px">Materials Off-site
                                        (unfixed)
                                    </div>
                                    <div class="w-32 px-2 py-2 -ml-px text-right" v-text="totalOffSiteValue"></div>
                                </div>
                                <div
                                    class="flex mt-0 px-0 text-sm text-gray-500 border-gray-200 border-b">
                                    <div class="flex-1 border-r border-gray-200 px-2 py-2 -ml-px">Retention Held <span
                                        class="font-bold">(5%)</span>
                                    </div>
                                    <div class="w-32 px-0 m-0 border-r text-right">
                                        <page-cell
                                            class="text-right text-sm m-0 p-0 pt-2 pr-2 min-h-[38px]"
                                            :class="isReadOnly()?'border-transparent':'border-gray-400'"
                                            :placeholder="'£0.00'"
                                            :useTextareaReadonly="true"
                                            :disabled="isReadOnly()"
                                            :read-only="isReadOnly()"
                                            v-model="applicationForPayment.retention"
                                            @change="save"
                                        ></page-cell>
                                    </div>
                                </div>
                                <div
                                    class="flex mt-0 px-0 text-sm text-gray-500 border-gray-200 border-b">
                                    <div class="flex-1 border-l border-gray-200 px-2 py-2 -ml-px bg-gray-50"></div>
                                </div>
                                <div
                                    class="flex mt-0 px-0 text-sm text-gray-700 border-gray-200 font-semibold">
                                    <div class="flex-1 border-r border-gray-200 px-2 py-2 -ml-px">Application Total
                                    </div>
                                    <div class="w-32 p-0 pt-2 pr-2 m-0 text-right"
                                         v-text="'ADDed in HERE'"></div>
                                </div>

                            </div>
                        </div>
                        <div class="pb-6 xl:col-span-6">
                            <ui-date-picker label="Application for Payment Date" name="date"
                                            v-model="applicationForPayment.date"
                                            class="xl:col-span-6 pb-6"
                                            placeholder="What is date for this applicationForPayment report?"
                                            :disabled="isReadOnly()"
                                            @change="save"
                            ></ui-date-picker>
                            <ui-textarea autoresize label="Comments" name="comments"
                                         v-model="applicationForPayment.comments"
                                         placeholder="Notes..."
                                         :disabled="isReadOnly()"
                                         @change="save"
                                         class="xl:col-span-12"></ui-textarea>
                        </div>
                    </div>
                    <send-log :send-log="combineSendLogs" v-if="applicationForPayment.sendLog" @revoke="revoke"
                              @resend="resend"></send-log>
                    <ui-data-grid-item label="Quick action" wide>
                        <div class="flex flex-col md:flex-row flex-wrap -m-2">
                            <a :href="applicationForPayment.getDownloadUrl()" tabindex="-1">
                                <ui-button-new class="m-2" icon="fas fa-file-pdf">Download As PDF</ui-button-new>
                            </a>
                            <ui-button-new class="m-2" icon="fas fa-print" @click="print">Print PDF</ui-button-new>
                        </div>
                    </ui-data-grid-item>

                </template>
                <template v-else-if="mode==='materials'">
                    <div class="pb-6 pt-2">
                        <div class="w-full mb-1">Materials On Site:</div>
                        <div class="w-full border-gray-300 border rounded-lg p-2">
                            <div class="pb-4">
                                <application-for-payment-material
                                    v-for="(material,index) in applicationForPayment.onSiteMaterials"
                                    :key="index"
                                    :material="material"
                                    :readonly="isReadOnly()"
                                    @change="save"
                                ></application-for-payment-material>
                                <!-- Total Amount. -->
                                <div class="flex text-xs text-gray-500 text-right font-semibold bg-white">
                                    <div class="flex-1 px-2 py-1">Total</div>
                                    <div class="w-20 -ml-px px-2 py-1" v-text="totalOnSiteValue">
                                    </div>
                                    <div class="w-6 flex-shrink-0 ml-2"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Materials Off Site -->
                    <div class="pb-6">
                        <div class="w-full mb-1">Materials Off-Site:</div>
                        <div class="w-full border-gray-300 border rounded-lg p-2">
                            <div class="pb-4">
                                <application-for-payment-material
                                    v-for="(material,index) in applicationForPayment.offSiteMaterials"
                                    :key="index"
                                    :material="material"
                                    :readonly="isReadOnly()"
                                    @change="save"
                                ></application-for-payment-material>
                                <!-- Total Amount. -->
                                <div class="flex text-xs text-gray-500 text-right font-semibold bg-white">
                                    <div class="flex-1 px-2 py-1">Total</div>
                                    <div class="w-20 -ml-px px-2 py-1" v-text="totalOffSiteValue">
                                    </div>
                                    <div class="w-6 flex-shrink-0 ml-2"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else-if="mode==='measure'">
                    <div class="w-full border-gray-300 border rounded-lg p-2">
                        <application-for-payment-section v-for="section in applicationForPayment.sections"
                                                         :key="section.id"
                                                         :section="section"
                                                         @updated="save"
                                                         :readonly="isReadOnly()"
                        ></application-for-payment-section>
                    </div>
                </template>
                <template v-else-if="mode==='dayworks'">
                    <div class="p-2 w-full border-gray-300 border rounded-lg bg-gray-50">
                        <div class="p-4 text-red-500"><span class="font-bold">Dayworks</span> are not currently
                            supported. You may enter
                            a manual figure to apply for on the Summary tab
                        </div>
                    </div>
                </template>
                <template v-else-if="mode==='preliminaries'">
                    <div class="w-full border-gray-300 border rounded-lg p-2">
                        <application-for-payment-task v-for="task in applicationForPayment.preliminaries" :key="task.id"
                                                      :measurable="false"
                                                      :readonly="isReadOnly()"
                                                      @updated="save"
                                                      :task="task"></application-for-payment-task>
                    </div>
                </template>
            </div>
            <div class="w-72 space-y-8 relative pt-4">
                <div class="w-72 space-y-1 fixed">
                    <application-for-payment-action-panel :applicationForPayment="applicationForPayment"
                                                          :user="user"
                                                          @deleted="(e) => $emit('deleted',e)"
                                                          @print="print"
                                                          @reflow="false"
                    ></application-for-payment-action-panel>
                    <div
                        style="overflow-y: auto; padding-right:12px; margin-top:12px; padding-top:12px; top:0px;"
                        :style="applicationForPayment && applicationForPayment.readonly?'height:calc(100vh - 250px)':'height:calc(100vh - 250px)'">
                        <application-for-payment-status-panel :application-for-payment="applicationForPayment"
                                                              @toggleEditMode="toggleEditMode"></application-for-payment-status-panel>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UiContainer from "../../ui/UiContainer.vue";
import UiDatePicker from "../../ui/UiDatePicker.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";
import UiDataGridItem from "../../ui/UiDataGridItem.vue";
import UiHeader from "../../ui/UiHeader.vue";
import UiInput from "../../ui/UiInput.vue";
import UiToggle from "../../ui/UiToggle.vue";
import {ApplicationForPayment} from "@models";
import ApplicationForPaymentSection from "./ApplicationForPaymentSection.vue";
import {resolveNumericText, toCurrency} from "../../../utils";
import ApplicationForPaymentMaterial from "./ApplicationForPaymentMaterial.vue";
import SendLog from "../../send-log/SendLog.vue";
import moment from "moment/moment";
import PageCell from "../../ui/PageCell.vue";
import EstimateStatusPanel from "../../estimation/estimates/EstimateStatusPanel.vue";
import user from "../../../services/User";
import EstimateTabs from "../../estimation/estimates/EstimateTabs.vue";
import ApplicationForPaymentStatusPanel from "./ApplicationForPaymentStatusPanel.vue";
import ApplicationForPaymentActionPanel from "./ApplicationForPaymentActionPanel.vue";
import ApplicationForPaymentTask from "./ApplicationForPaymentTask.vue";

export default {
    components: {
        ApplicationForPaymentTask,
        ApplicationForPaymentActionPanel,
        ApplicationForPaymentStatusPanel,
        EstimateTabs,
        EstimateStatusPanel,
        PageCell,
        SendLog,
        ApplicationForPaymentMaterial,
        ApplicationForPaymentSection,
        UiToggle, UiInput, UiHeader, UiDataGridItem, UiDatePicker, UiButtonNew, UiContainer
    },
    props: {
        packageReference: null,
        packageName: null,
        selectedItem: null,
        selectItem: Function,
    },
    data() {
        return {
            applicationForPayment: null,
            applicationForPaymentKey: 0,
            busy: false,
            totalOnSiteValue: '...',
            totalOffSiteValue: '...',
            mode: 'summary',
        }
    },
    computed: {
        user() {
            return user
        },
        combineSendLogs() {
            return this.applicationForPayment.sendLog.map((a) => {
                return a;
            }).concat(...this.applicationForPayment.attendees.map((a) => a.sendLog ? a.sendLog.map((b) => {
                return b;
            }) : [])).sort((a, b) => moment(b.requested.at).unix() - moment(a.requested.at).unix())
        },
    },
    methods: {
        isReadOnly() {
            return this.applicationForPayment.readonly
        },
        async toggleEditMode(e) {
            this.applicationForPayment.readonly = e
            this.applicationForPaymentKey++
        },
        revoke(i) {
            this.applicationForPayment.revoke(i.id);
        },
        resend(i) {
            this.applicationForPayment.resend(i.id);
        },
        send() {
            this.$modals.open('application-for-payment-send-modal', {
                title: `Send Application for Payment`,
                button: 'Send Application for Payment',
                applicationForPayment: this.applicationForPayment,
                handle: async (daily, modal) => {
                    modal.close()
                }
            })
        },
        print() {

        },
        async save() {
            await this.applicationForPayment.save()
        },
        sumMeasuredWorks() {
            let val = 0;
            if (this.applicationForPayment.sections) {
                this.applicationForPayment.sections.forEach((section) => {
                    section.tasks.forEach((task) => {
                        task.items.forEach((item) => {
                            val += resolveNumericText(item.applyingFor)
                        })
                    })
                })
            }
            return toCurrency(val);
        },
    },
    async mounted() {
        this.applicationForPayment = await ApplicationForPayment.find(this.selectedItem.id);
        this.totalOnSiteValue = toCurrency(this.applicationForPayment.onSiteMaterials.reduce((acc, cur) => {
            return acc + resolveNumericText(cur.total)
        }, 0));
        this.totalOffSiteValue = toCurrency(this.applicationForPayment.offSiteMaterials.reduce((acc, cur) => {
            return acc + resolveNumericText(cur.total)
        }, 0));
        this.applicationForPayment.originalContractValue = toCurrency(resolveNumericText(this.applicationForPayment.originalContractValue));
        this.applicationForPayment.totalVariationsValue = toCurrency(resolveNumericText(this.applicationForPayment.totalVariationsValue));
        this.applicationForPayment.contractedWorksValue = toCurrency(resolveNumericText(this.applicationForPayment.originalContractValue) + resolveNumericText(this.applicationForPayment.totalVariationsValue));
        this.applicationForPayment.readonly = true;
        this.applicationForPaymentKey++;
    },
    beforeUpdate() {
    }
}
</script>
